export default __webpack_public_path__ + "static/media/signedOff-shaded.6dc14c4c.png";